import { For } from "solid-js";
import { Link } from "@solidjs/meta";
import { useLocation } from "@solidjs/router";
import { LANGUAGES, SUPPORTED_SEGMENTS, DEFAULT_SEGMENT } from "@/locales/registry";

const BASE = "https://lyszt.net";
const STRIP = new RegExp(`^/(${SUPPORTED_SEGMENTS.join("|")})(/|$)`);

export function HreflangLinks() {
  const location = useLocation();
  const bare = () => {
    const stripped = location.pathname.replace(STRIP, "/");
    return stripped === "/" ? "" : stripped.replace(/\/$/, "");
  };

  return (
    <>
      <Link rel="alternate" hreflang="x-default" href={`${BASE}/${DEFAULT_SEGMENT}${bare()}`} />
      <For each={LANGUAGES}>
        {(l) => <Link rel="alternate" hreflang={l.hreflang} href={`${BASE}/${l.segment}${bare()}`} />}
      </For>
    </>
  );
}
